import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { WindowOpen, borwserHistory } from '@zenlayer/portal-utils';
import { Icon } from '@zenlayer/zen-design';
import classnames from 'classnames';
import cls from './index.module.less';
import '@zenlayer/zen-design-icons/assets/Loading3QuartersOutlined.svg';
import '@zenlayer/zen-design-icons/assets/general/JumpLink.svg';
import { pickDomAttrs } from '@zenlayer/zen-design/esm/_util/utils';
const isExternalLink = (href) => {
    return ['https://', 'http://', '//'].some((it) => href.startsWith(it));
};
export const LinkButton = ({ disabled, loading, target, href, block, prefix, suffix, children, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onFocus, className, style, loadingClickable, ...restProps }) => {
    const attrs = pickDomAttrs(restProps);
    const enable = (!disabled && !loading) || (!disabled && loadingClickable);
    const _href = href && enable ? href : undefined;
    const _prefix = loading === 'before' || loading === true ? (_jsx(Icon, { type: "Loading3QuartersOutlined", spin: true, block: true })) : (prefix);
    const _suffix = loading === 'after' ? (_jsx(Icon, { type: "Loading3QuartersOutlined", spin: true, block: true })) : (suffix);
    const _onClick = (e) => {
        if (_href) {
            e.preventDefault();
            e.stopPropagation();
            switch (target) {
                case 'tab':
                    new WindowOpen(_href);
                    break;
                case 'replace':
                    if (isExternalLink(_href)) {
                        window.location.replace(_href);
                    }
                    else {
                        borwserHistory.replace(_href, {});
                    }
                    break;
                default:
                    if (isExternalLink(_href)) {
                        window.location.assign(_href);
                    }
                    else {
                        borwserHistory.push(_href, {});
                    }
                    break;
            }
        }
        else {
            typeof onClick === 'function' && onClick(e);
        }
    };
    return (_jsxs("a", { ...attrs.data, href: _href, onClick: (e) => {
            enable && _onClick(e);
        }, onMouseDown: (e) => {
            enable && typeof onMouseDown === 'function' && onMouseDown(e);
        }, onMouseUp: (e) => {
            enable && typeof onMouseUp === 'function' && onMouseUp(e);
        }, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, className: classnames(cls.linkButton, className, {
            [cls.disabled]: !!disabled,
            [cls.loading]: loadingClickable ? false : !!loading,
            [cls.block]: !!block,
        }), style: style, children: [_prefix, !!children && _jsx("span", { children: children }), _suffix, target === 'tab' && _jsx(Icon, { type: "general/JumpLink", block: true })] }));
};
